import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../RootState";
import { GatewayType } from "../../Types/Gateway.model";

export interface GatewayStateModel {
  activeGateway: GatewayType | null;
}

const initialState: GatewayStateModel = {
  activeGateway: null,
};

const gatewaySlice = createSlice({
  name: "gateway",
  initialState,
  reducers: {
    setActiveGateway: (
      state: GatewayStateModel,
      action: PayloadAction<any>
    ) => {
      state.activeGateway = action.payload;
    },
  },
});

export const { setActiveGateway } = gatewaySlice.actions;

export default gatewaySlice.reducer;

export const activeGatewaySelector = (state: RootState) =>
  state.gateway.activeGateway;
